import React from "react";
import { observer } from "mobx-react";
import Utils from "Utils/utils";
import DonutChart from "./DonutChart";
import LabelComponent from "./LabelComponent";
import BarChart from "./BarChart";

const SequenceGraphComponent = observer((props = {}) => {
  const { graphDataArr = [], loader = false, hideTotalCount = false, customClassName = "", useBarChartFor = [] } = props || {};

  const transFormDataArr = (
    dataArr = [],
    isRoundOff = false,
    totalCount = 0
  ) => {
    return [...dataArr].map(({ label, value, color }) => {
      let tempValue = totalCount > 0 ? (value / totalCount) * 100 : 0;
      return {
        label,
        value: isRoundOff
          ? tempValue
            ? `${tempValue?.toFixed(2)}%`
            : 0
          : tempValue,
        color
      };
    });
  };

  return (
    <div className={`sequenceGraphCont ${customClassName}`}>
      {!loader ? (
        graphDataArr?.length > 0 &&
        graphDataArr.map((item, index) => {
          const { header = "", totalCount = 0, dataArr = [], type = "" } = item || {};
          const useBarChart = useBarChartFor.some(name => header.toLowerCase() === name.toLowerCase());
          
          return (
            <div className="sequenceAnalyticsCard" key={index}>
              <div className="headerCont">
                <span className="headerName">{header}</span>
                {!hideTotalCount && type !== 'stats' && (
                  <span className="totalCount">
                    {Utils.formatNumberToStringInUSFormat(totalCount) || 0}
                  </span>
                )}
              </div>
              {useBarChart ? (
                <div className="barGraphSection">
                  <BarChart data={dataArr} />
                </div>
              ) : type === 'stats' ? (
                <div className="statsSection" style={{ padding: '20px', gap: '15px', display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center', height: '100%' }}>
                  {dataArr.map((stat, idx) => (
                    <div key={idx} className="statItem" style={{ display: 'flex', flexDirection: 'column', gap: '5px', textAlign: 'center' }}>
                      <span className="statLabel" style={{ fontSize: '14px', color: '#666' }}>{stat.label}</span>
                      <span className="statValue" style={{ fontSize: '24px', fontWeight: '500', color: stat.color || '#333' }}>{stat.value}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="donutGraphSection">
                  <DonutChart
                    data={transFormDataArr(dataArr, false, totalCount)}
                  />
                  <LabelComponent
                    labelArr={
                      header?.toLowerCase() === "emails"
                        ? transFormDataArr(dataArr, true, totalCount)
                        : dataArr
                    }
                  />
                </div>
              )}
            </div>
          );
        })
      ) : (
        <SequenceGraphContLoader loader={loader} />
      )}
    </div>
  );
});

const SequenceGraphContLoader = ({ loader = false }) => {
  return Array.from({ length: 3 }).map((_, index) => (
    <div className="sequenceAnalyticsCard" key={index}>
      <div className="headerCont">
        <span className="headerNameLoader linear-background" />
        <span className="totalCountLoader linear-background" />
      </div>
      <div className="donutGraphSection">
        <DonutChart loader={loader} />
        <LabelComponent loader={loader} />
      </div>
    </div>
  ));
};

export default SequenceGraphComponent;
export { SequenceGraphComponent };
